import { Navigate, Route, Routes } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { PanelPage } from './pages/PanelPage';
import { PasswordResetPage } from './pages/PasswordResetPage';
import { RegisterPage } from './pages/RegisterPage';
import { CheckoutSuccessPage } from './pages/CheckoutSuccessPage';
import { CustomerWalletPage } from './pages/CustomerWalletPage';
import { LegalPage } from './pages/LegalPage';

export function AppRouter() {
  return <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/recuperar" element={<PasswordResetPage />} />
    <Route path="/registro" element={<RegisterPage />} />
    <Route path="/registro/exito" element={<CheckoutSuccessPage />} />
    <Route path="/panel" element={<PanelPage />} />
    <Route path="/t/:slug" element={<CustomerWalletPage />} />
    <Route path="/aviso-de-privacidad" element={<LegalPage />} />
    <Route path="/terminos" element={<LegalPage />} />
    <Route path="/cancelaciones" element={<LegalPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>;
}
